module.exports = __webpack_public_path__ + "static/media/9.0f7118cb.png";